import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import WhyItMatters from "./components/WhyItMatters";
import Prevention from "./components/Prevention";
import Programs from "./components/Programs";
import Learn from "./components/Learn";
import Steps from "./components/Steps";
import Research from "./components/Research";
import WhoItsFor from "./components/WhoItsFor";
import About from "./components/About";
import Faq from "./components/Faq";
import SignupForms, { QuickInterestForm } from "./components/SignupForms";
import Footer from "./components/Footer";
import Admin from "./components/admin/Admin";
import EsLanding from "./es/EsLanding";
import Flyer from "./pages/Flyer";

function Landing() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
        let lenis;
        let raf = 0;
        let cancelled = false;
        import("lenis").then(({ default: Lenis }) => {
            if (cancelled) return;
            lenis = new Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
            window.__lenis = lenis;
            const loop = (time) => {
                lenis.raf(time);
                raf = requestAnimationFrame(loop);
            };
            raf = requestAnimationFrame(loop);
        });
        return () => {
            cancelled = true;
            cancelAnimationFrame(raf);
            if (lenis) lenis.destroy();
            window.__lenis = undefined;
        };
    }, []);

    return (
        <div className="min-h-screen bg-cream font-body text-ink">
            <a
                href="#main"
                className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-ink focus:px-5 focus:py-3 focus:text-cream"
            >
                Skip to content
            </a>
            <div className="grain-overlay" aria-hidden="true" />
            <Header />
            <main id="main">
                <Hero />
                <QuickInterestForm />
                <Marquee />
                <WhyItMatters />
                <Prevention />
                <Programs />
                <Learn />
                <Steps />
                <Research />
                <WhoItsFor />
                <About />
                <Faq />
                <SignupForms />
            </main>
            <Footer />
        </div>
    );
}

function AppRouter() {
    const location = useLocation();
    useEffect(() => {
        document.documentElement.lang = location.pathname === "/es" ? "es" : "en";
        if (location.pathname === "/es") {
            document.title = "Fall Safe Ready | Clases de caída segura para adultos activos de 55+ en Arlington, VA";
        } else if (location.pathname === "/flyer") {
            document.title = "One-page flyer — Fall Safe Ready";
        } else {
            document.title = "Fall Safe Ready | Safe-falling classes for active adults 55+ in Arlington, VA";
        }
    }, [location.pathname]);
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/es" element={<EsLanding />} />
            <Route path="/flyer" element={<Flyer />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

export default function App() {
    return (
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    );
}